import React, { Component } from 'react';
import {toQueryString} from "../utils/utils";
import Slider from '@material-ui/lab/Slider';
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import ToggleButton from "@material-ui/lab/ToggleButton";

class FilterList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tags: [],
            activeTags: [],
            maxPrice: 3000,
            minRooms: 0,
            minSize: 0,
            buyRent: "rent"
        };
        this.removeFilter = this.removeFilter.bind(this);
        this.addFilter = this.addFilter.bind(this);
        this.isRent = this.isRent.bind(this);
        this.handleBuyRentChange = this.handleBuyRentChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.searchParams.q !== prevProps.searchParams.q ||
            this.props.searchParams.l !== prevProps.searchParams.l ||
            this.props.searchParams.lat !== prevProps.searchParams.lat ||
            this.props.searchParams.lng !== prevProps.searchParams.lng ||
            this.props.searchParams.radius !== prevProps.searchParams.radius ||
            this.props.searchParams.tags !== prevProps.searchParams.tags
        ) {
            this.updateFilterList();
        }
    }

    updateFilterList() {
        const activeTags = this.props.searchParams.tags ? this.props.searchParams.tags.split(",") : [];
        fetch(this.props.url + "?" + toQueryString(this.props.searchParams))
            .then(results => {
                if (!results.ok) {
                    throw new Error(results.statusText);
                }
                return results.json();
            })
            .then(tags => {
                this.setState({ tags, activeTags })
            })
            .catch(e => console.error(e));
    }

    handleBuyRentChange(val) {
        this.setState({
            buyRent: val,
            maxPrice: val === "rent" ? 3000 : 500000
        }, () => this.props.onFilter(this.state));
    }

    handleStateChange(newState) {
        this.setState(newState, () => this.props.onFilter(this.state));
    }

    render() {
        return (
            <div className="filterfields">
                <div className="container">
                    <div className="filter-simple">
                        <label htmlFor="buy-rent">
                            <span style={{cursor: "pointer"}} onClick={this.reset}>Mieten / Kaufen</span>
                        </label>
                        <ToggleButtonGroup style={{maxWidth: "131px"}}
                                           id="buy-rent"
                                           exclusive={true}
                                           value={this.state.buyRent}
                                           onChange={(e, val) => this.handleBuyRentChange(val)}>
                            <ToggleButton value="rent">Mieten</ToggleButton>
                            <ToggleButton value="buy">Kaufen</ToggleButton>
                        </ToggleButtonGroup>
                    </div>
                    <div className="filter-simple">
                        <label htmlFor="price-slider">
                            <span style={{cursor: "pointer"}}>
                                Max. {this.isRent() ? "Miete" : "Kaufpreis"}
                            </span>
                        </label>
                        <div className="slider">
                            <Slider id="price-slider"
                                    min={0}
                                    max={this.isRent() ? 5000 : 1000000}
                                    step={this.isRent() ? 10 : 1000}
                                    value={this.state.maxPrice}
                                    onChange={(e, val) => this.setState({maxPrice: val})}
                                    onDragEnd={() => this.handleStateChange({maxPrice: this.state.maxPrice})}
                            />
                        </div>
                        <div>{this.state.maxPrice} €</div>
                    </div>
                    <div className="filter-simple">
                        <label htmlFor="room-slider">
                            <span style={{cursor: "pointer"}}>Min. Zimmer</span>
                        </label>
                        <div className="slider">
                            <Slider id="room-slider"
                                    min={0}
                                    max={30}
                                    step={1}
                                    value={this.state.minRooms}
                                    onChange={(e, val) => this.setState({minRooms: val})}
                                    onDragEnd={() => this.handleStateChange({minRooms: this.state.minRooms})}/>
                        </div>
                        <div>{this.state.minRooms}</div>
                    </div>
                    <div className="filter-simple">
                        <label htmlFor="space-slider">
                            <span style={{cursor: "pointer"}}>Min. Fläche</span>
                        </label>
                        <div className="slider">
                            <Slider id="space-slider"
                                    min={0}
                                    max={500}
                                    step={10}
                                    value={this.state.minSize}
                                    onChange={(e, val) => this.setState({minSize: val})}
                                    onDragEnd={() => this.handleStateChange({minSize: this.state.minSize})}/>
                        </div>
                        <div>{this.state.minSize} m&sup2;</div>
                    </div>
                    {this.state.activeTags && this.state.activeTags.length > 0 && (
                        <div className="filter">
                            <label htmlFor="tags"><span style={{cursor: "pointer"}}>Angewandte Tags</span></label>
                            <div id="tags">
                                <ul className="tag-list">
                                    {this.state.activeTags
                                        .filter((value, index, self) => self.indexOf(value) === index)
                                        .map(tagName => { return (
                                            <li key={"active-filter-" + tagName}
                                                className="taggle applied"
                                                onClick={() => this.removeFilter(tagName)}>{tagName}</li>
                                        )})
                                    }
                                </ul>
                            </div>
                        </div>
                    )}
                    <div style={{clear: "both"}}/>
                    {this.state.tags && this.state.tags.length > 0 && (
                        <div className="filter">
                            <label htmlFor="most-tagged">Meist vertaggt</label>
                            <div id="most-tagged">
                                <ul className="tag-list">
                                    {this.state.tags
                                        .filter(tag => this.state.activeTags.includes(tag.name) === false)
                                        .map(tag => { return (
                                            <li key={tag.name}
                                                className="taggle"
                                                onClick={() => this.addFilter(tag.name)}>{tag.name}</li>
                                        )})
                                    }
                                </ul>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    isRent() {
        return this.state.buyRent === "rent";
    }

    removeFilter(tagName) {
        const activeTags = this.state.activeTags.filter(t => t !== tagName);
        this.setState({ activeTags }, () => this.props.onFilter(this.state));
    }

    addFilter(tagName) {
        let activeTags = this.state.activeTags;
        activeTags.push(tagName);
        this.setState({ activeTags }, () => this.props.onFilter(this.state));
    }
}

export default FilterList;
